import React, { useEffect, useState } from "react";
import "./MonthlyOffers.css";

const SHEET_CSV_URL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vRYG6JNvoH_NmpTnyqmFeHm3kSyDzZS5d0dQUfGJs19K2hH-K9xA0_f0QV7a647pk0bGy8sveq7ODmI/pub?output=csv";

const MonthlyOffers = () => {
  const [offers, setOffers] = useState([]);
  const [city, setCity] = useState("Your City");

  // Get month name
  const month = new Date().toLocaleString("default", { month: "long" });

  // Fetch sheet data
  useEffect(() => {
    fetch(SHEET_CSV_URL)
      .then((res) => res.text())
      .then((csvText) => {
        const rows = csvText.trim().split("\n").slice(1);
        const data = rows.map((r) => {
          const [ImageURL, Title, Text, Subheading, Link] = r.split(",");
          return { ImageURL, Title, Text, Subheading, Link };
        });
        setOffers(data);
      })
      .catch(console.error);
  }, []);

  // Get user city via geolocation + reverse geocode
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          try {
            const resp = await fetch(
              `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${pos.coords.latitude}&longitude=${pos.coords.longitude}&localityLanguage=en`
            );
            const json = await resp.json();
            if (json.locality) setCity(json.locality);
          } catch {}
        },
        () => {}
      );
    }
  }, []);

  return (
    <div className="monthly-offers-page">
      <h1>
        Single Tap {month} Offers In {city}
      </h1>
      <div className="offers-grid">
        {offers.map((o, idx) => (
          <div className="offer-card" key={idx}>
            <img src={o.ImageURL} alt={o.Title} />
            <h3>{o.Title}</h3>
            <p>{o.Text}</p>
            <h4>{o.Subheading}</h4>
            <a href={o.Link} className="explore-btn" target="_blank" rel="noreferrer">
              Explore
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MonthlyOffers;
